export default "__VITE_ASSET__BTPWFRHW__"